import { render } from "./SsmLogo.vue?vue&type=template&id=1b7053f6&scoped=true"
import script from "./SsmLogo.vue?vue&type=script&lang=js"
export * from "./SsmLogo.vue?vue&type=script&lang=js"

import "./SsmLogo.vue?vue&type=style&index=0&id=1b7053f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7053f6"]])

export default __exports__